import * as React from 'react';
import { useState, useEffect } from 'react';
import { Box, Grid, FormControl, Paper, Button, TextField, MenuItem, Snackbar, Alert, Typography } from '@mui/material';
import { settingApi } from "../../api/api"; // Import your API method
const General = () => {
    const [theme, setTheme] = useState("");  
    const [themeType, setThemeType] = useState("");  
    const [primaryColor, setPrimaryColor] = useState("#ff5733");
    const [secondaryColor, setSecondaryColor] = useState("#33c1ff");
    const [themeColor, setThemeColor] = useState("#3498db");
    const [loading, setLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [availableThemes, setAvailableThemes] = useState([]);
    const [availableThemeTypes, setAvailableThemeTypes] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null); // Store file
    const [darkImage, setDarkImage] = useState(null); // Store file
    const [ImagePreview, setImagePreview] = useState(null); // Store image preview URL
    const [darkPreview, setDarkPreview] = useState(null); // Store image preview URL
    const [propertyErrors, setPropertyErrors] = useState({});
    // Modal state
    const [openModal, setOpenModal] = useState(false);
    const [newColor, setNewColor] = useState("");
    // Fetch theme data from API on component mount
    useEffect(() => {
        const getAllThemes = async () => {
            try {
                const response = await settingApi.getTheme();  // Assuming this API gets the available themes
                const data = response.data;
                setAvailableThemes(data);
                if (data.length > 0) {
                    const firstTheme = data[0].theme_name;
                    setTheme(firstTheme);
                }
            } catch (error) {
                console.error("Failed to fetch theme data:", error);
                setSnackbarMessage("Failed to fetch theme data");
                setSnackbarSeverity("error");
                setSnackbarOpen(true);
            }
        };
        getAllThemes();
    }, []);
    const handleLightImageChange = (event) => {
        const file = event.target.files[0];
        
        if (file) {
            setSelectedImage(file); // Store the actual file for uploading
            setImagePreview(URL.createObjectURL(file));
        }
    };
    const handleDarkImageChange = (event) => {
        const file1 = event.target.files[0];
        if (file1) {
           
            setDarkImage(file1);  // Store the actual file for uploading
           
            // console.log("dark",URL.createObjectURL(file1))
            setDarkPreview(URL.createObjectURL(file1));  // Create a temporary URL for the preview
        }
        
    };

   
 
 
    const handleSave = async (event) => {
        event.preventDefault();
        setLoading(true);
   
        const fd = new FormData();
        fd.append("theme_name", theme);  // Append theme name
       
        // Append the light and dark images as binary files to FormData
        if (selectedImage) {
            fd.append("light_logo", selectedImage);  // Append light logo file
        }
        if (darkImage) {
            fd.append("dark_logo", darkImage);  // Append dark logo file
        }
        for (let pair of fd.entries()) {
            console.log(pair[0], pair[1]); // Logs key-value pairs of FormData
        }
       
   
        // console.log("Form Data being sent to the backend:");
        // console.log({
        //     theme,
        //     selectedImage,
        //     darkImage
        // });
   
        try {
            // Send the form data to your backend API (assuming addThemeType is your API method)
            const response = await settingApi.generalTheme(fd);  
   
            if (response.status === 200) {
                setSnackbarMessage("Theme Changed successfully!");
                setSnackbarSeverity("success");
                setSnackbarOpen(true);
                resetForm();  // Reset the form fields after successful save
            } else {
                throw new Error("Failed to change theme");
            }
        } catch (error) {
            // If the API call fails, show an error message
            setSnackbarMessage("Failed to change theme. Please try again.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
            console.error(error.message);
        } finally {
            setLoading(false);  // Set loading to false once the operation is complete
        }
    };
   
   
    const resetForm = () => {
        setThemeType("Light");
        setPrimaryColor("#fdd733");
        setSecondaryColor("#34c1ff");
        // setTheme3Color("#3498db");
    };
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4, px: { xs: 1, sm: 2 } }}>
  <div style={{ width: "100%", maxWidth: "900px" }}>
    <Box sx={{ border: "2px solid lightgray", borderRadius: "5px", mb: 2 }}>
      <Typography variant="h4" sx={{ m: 2, fontSize: { xs: "1.2rem", sm: "1.5rem" } }}>
        General
      </Typography>
    </Box>
 
    <Paper elevation={12} sx={{ p: { xs: 2, sm: 3 } }}>
      <form onSubmit={handleSave}>
        {/* Theme Dropdown */}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                select
                label="Select Theme"
                value={theme}
                onChange={(e) => setTheme(e.target.value)}
                variant="outlined"
                fullWidth
              >
                {availableThemes.map((theme) => (
                  <MenuItem key={theme.id} value={theme.theme_name}>
                    {theme.theme_name}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>
 
          {/* Light and Dark Logos */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h6"
              sx={{ color: "#13216e", fontWeight: 600, fontSize: { xs: "16px", sm: "20px" }, mb: 1 }}
            >
              Light Logo
            </Typography>
            <label htmlFor="display-image-upload">
              <Button
                variant="contained"
                component="span"
                fullWidth
                sx={{
                  backgroundColor: "#1565c0",
                  "&:hover": { backgroundColor: "#0d47a1" },
                }}
              >
                Choose Display Image
              </Button>
            </label>
            <input
              id="display-image-upload"
              type="file"
              onChange={handleLightImageChange}
              style={{ display: "none" }}
            />
            {ImagePreview && (
              <Box sx={{ mt: 2 }}>
                <img
                  src={ImagePreview}
                  alt="Light Logo"
                  style={{ width: "100%", maxHeight: "150px", objectFit: "contain", borderRadius: 8 }}
                />
              </Box>
            )}
          </Grid>
 
          <Grid item xs={12} md={6}>
            <Typography
              variant="h6"
              sx={{ color: "#13216e", fontWeight: 600, fontSize: { xs: "16px", sm: "20px" }, mb: 1 }}
            >
              Dark Logo
            </Typography>
            <label htmlFor="display-image-upload1">
              <Button
                variant="contained"
                component="span"
                fullWidth
                sx={{
                  backgroundColor: "#1565c0",
                  "&:hover": { backgroundColor: "#0d47a1" },
                }}
              >
                Choose Display Image
              </Button>
            </label>
            <input
              id="display-image-upload1"
              type="file"
              onChange={handleDarkImageChange}
              style={{ display: "none" }}
            />
            {darkPreview && (
              <Box sx={{ mt: 2 }}>
                <img
                  src={darkPreview}
                  alt="Dark Logo"
                  style={{ width: "100%", maxHeight: "150px", objectFit: "contain", borderRadius: 8 }}
                />
              </Box>
            )}
          </Grid>
        </Grid>
 
        {/* Buttons */}
        <Grid container spacing={2} sx={{ mt: 3 }}>
          <Grid item xs={12} sm={6}>
            <Button
              type="button"
              variant="outlined"
              fullWidth
              onClick={resetForm}
              disabled={loading}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading}
            >
              {loading ? "Saving..." : "Save"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
 
    {/* Snackbar */}
    <Snackbar
      open={snackbarOpen}
      autoHideDuration={3000}
      onClose={() => setSnackbarOpen(false)}
    >
      <Alert
        onClose={() => setSnackbarOpen(false)}
        severity={snackbarSeverity}
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </div>
</Box>
 
    );
};
export default General;
 